import React, { useEffect, useState, useRef } from 'react';
import socket from '../../sockets';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft, FaPaperPlane, FaPaperclip } from 'react-icons/fa';
import Message from '../../components/Message';
import UserImage from "../../assets/user.png";
import "./chats.css";
import { selectCurrentUser } from '../../app/selectors/authSelectors';

const UserChat = () => {
    const user = useSelector(selectCurrentUser);
    const navigate = useNavigate();
    const { friend } = useParams();


    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState("");
    const [files, setFiles] = useState([]);
    const [loadingMsgs, setLoadingMsgs] = useState(false);
    const [sending, setSending] = useState(false);
    const [conversation, setConversation] = useState(null)
    const [roomId, setRoomId] = useState(null);
    // const [friendData,setFriendData] = useState({})

    const messagesEndRef = useRef(null);
    const location = useLocation()
    const partner = location.state?.partner;

    //  console.log(friend)
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    // Load Message History
    useEffect(() => {
        const loadHistory = async () => {
            try {
                setLoadingMsgs(true);
                const res = await api.get(`/chats/${friend}`);
                // console.log(res)
                setRoomId(res?.data.chat._id)
                setMessages(res.data.messages);
            } catch (error) {
                // console.log(error)
                setLoadingMsgs(false)
                // toast.error(error.response.data.message);
            } finally {
                setLoadingMsgs(false);
            }
        };
        loadHistory();
    }, [friend]);

    // Socket Setup
    useEffect(() => {
        if (!roomId) return;

        socket.emit("join_room", roomId);

        socket.on("receive_message", (data) => {

            console.log("received_message:", data)
            // Check if message already exists (prevents duplicates from optimistic UI)
            setMessages((prev) => {
                const exists = prev.find(m => m._id === data._id);
                return exists ? prev : [...prev, data];
            });
        });

        return () => {
            socket.off("receive_message");
        };
    }, [roomId]);

    // Scroll whenever messages update
    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const uploadToS3 = async (file) => {
        const { data } = await api.post("/uploads/presign", {
            filename: file.name,
            contentType: file.type,
        });

        await fetch(data.uploadUrl, {
            method: "PUT",
            headers: { "Content-Type": file.type },
            body: file,
        });

        const baseType = file.type.split("/")[0];
        return {
            key: data.key,
            type: baseType === "image" ? "image" : baseType === "video" ? "video" : "document",
            mimeType: file.type,
            name: file.name,
        };
    };

    // console.log(frd?._id,conversation)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!user?._id) {
            toast.error("Please log in again.");
            return;
        }
        if (!message.trim() && files.length === 0) return;
        if (sending) return;

        setSending(true);
        const tempId = Date.now();

        try {
            let uploadedFiles = [];
            if (files.length > 0) {
                uploadedFiles = await Promise.all(files.map(uploadToS3));
            }

            const payload = {
                message,
                sender: user._id,
                receiver: friend,
                room: conversation ? conversation._id : null,
                files: uploadedFiles,
            };
            // console.log(payload)

            socket.emit("send_message", payload);

            // Optimistic UI Update
            setMessage("");
            setFiles([]);
            setMessages((prev)=>[...prev,payload])
        } catch (err) {
            toast.error("Send failed");
        } finally {
            setSending(false);
        }
    };


    return (
        <div className="mobile-chat-container">
            {/* Header */}
            <header className="chat-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <FaArrowLeft />
                </button>
                <div className="partner-info">
                    <img src={partner?.profilePic?.url || UserImage} alt="profile" />
                    <span className="partner-name">{partner ? `${partner?.firstname} ${partner?.lastname}` : "Chat"}</span>
                </div>
            </header>

            {/* Messages Area */}
            <main className="messages-display">
                {loadingMsgs ? (
                    <div className="chat-status">Loading conversation...</div>
                ) : (
                    <>
                        {messages.map((msg) => (
                            <Message
                                key={msg._id}
                                message={msg}
                                currentUserId={user._id}
                            />
                        ))}
                        <div ref={messagesEndRef} />
                    </>
                )}
            </main>

            {/* Input Bar */}
            <form className="chat-input-wrapper" onSubmit={handleSubmit}>
                <label className="attachment-btn">
                    <FaPaperclip />
                    <input
                        type="file"
                        multiple
                        hidden
                        onChange={(e) => setFiles(Array.from(e.target.files))}
                    />
                </label>

                <textarea
                    placeholder="Message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={1}
                />

                <button type="submit" className="send-btn" disabled={sending || (!message.trim() && files.length === 0)}>
                    {sending ? <div className="spinner"></div> : <FaPaperPlane />}
                </button>
            </form>

            {/* File Preview Strip (Optional UI) */}
            {files.length > 0 && (
                <div className="file-preview-strip">
                    {files.map((f, i) => <span key={i}>{f.name}</span>)}
                    <button onClick={() => setFiles([])}>Clear</button>
                </div>
            )}
        </div>
    );
};

export default UserChat;